/**
 * Auth error codes.
 */
export enum AuthErrorCode {
  CHECK_USER_FAILED = 'error.auth.check_user.failed',
  VERIFICATION_FAILED = 'error.auth.verification.failed',
}

/** Auth login mode for error meta; aligns with cb-hp-ui AuthLoginMode. Values are flow identifiers, not credentials. */
export const AuthLoginMode = {
  OTP: 'OTP',
  PASSWORD: 'PASSWORD', // NOSONAR - auth flow type label for error meta, not a hard-coded password
} as const;
